import styled from 'styled-components'

import { SeparatorVertical } from './common'
import { TradingPairExploreItemMetricsFees } from './pair-explore-item-metrics-fees'
import { TradingPairExploreItemMetricsLiquidity } from './pair-explore-item-metrics-liquidity'
import { TradingPairExploreItemMetricsMcap } from './pair-explore-item-metrics-mcap'
import { TradingPairExploreItemMetricsPercent } from './pair-explore-item-metrics-percent'
import { TradingPairExploreItemMetricsTxs } from './pair-explore-item-metrics-txs'
import { TradingPairExploreItemMetricsVolume } from './pair-explore-item-metrics-volume'

import type { PairMetrics, PairModel } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  pair: PairModel
  statsPeriod: PairMetrics.MetricsSpan
} & ClassNameProps

export const TradingPairExploreItemMetricsSummarySmall: React.FC<Props> = ({
  pair,
  className,
  statsPeriod,
}) => {
  return (
    <Root className={className}>
      <FirstRow>
        <TradingPairExploreItemMetricsMcap pair={pair} />
        <SeparatorVertical vertical />

        <TradingPairExploreItemMetricsVolume
          pair={pair}
          volumePeriod={statsPeriod}
        />
        <SeparatorVertical vertical />

        <TradingPairExploreItemMetricsLiquidity pair={pair} />
        <SeparatorVertical vertical />

        <TradingPairExploreItemMetricsTxs
          pair={pair}
          statsPeriod={statsPeriod}
        />
      </FirstRow>

      <SecondRow>
        <TradingPairExploreItemMetricsFees pair={pair} />
        <TradingPairExploreItemMetricsPercent
          pair={pair}
          priceChangePeriod={statsPeriod}
        />
      </SecondRow>
    </Root>
  )
}

const Root = styled.div`
  pointer-events: none;
  color: var(--textA-8);

  display: grid;
  gap: 3px;
`

const Row = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;

  gap: 3px;
`
const FirstRow = styled(Row)`
  justify-content: stretch;
`
const SecondRow = styled(Row)`
  justify-content: space-between;
`
